import type { CenterFragment, SubscriptionFragment } from "@/generated/client.generated";
import { sort } from "rambda";
import { UserJourney } from "./types";

export function sortSubscriptionList(accountTypeOptions: ReadonlyArray<SubscriptionFragment>) {
  return sort(
    (a: SubscriptionFragment, b: SubscriptionFragment) => {
      return a.index >= b.index ? 1 : -1;
    },
    [...accountTypeOptions],
  );
}

//Mapper over til formatet backend krever. Stor bokstav på alle ord
export function userJourneyToRecurrenceString(userJourney: UserJourney) {
  switch (userJourney) {
    case UserJourney.Recurring:
      return "Recurring";
    case UserJourney.Single:
      return "OneTime";
    case UserJourney.Organization:
      return "Recurring";
    default:
      return "Recurring";
  }
}

export const sortCenters = (centers: Array<CenterFragment>) =>
  sort((a: CenterFragment, b: CenterFragment) => {
    return a.index >= b.index ? 1 : -1;
  }, centers);
